define(['jquery', 'bootstrap', 'validation', 'fv-phone', 'fv-recaptcha'], function ($) {
    var _internals = {
        showModal: function (target, options) {
            var $this = $(target);
            var url = $this.data('remote');
            var container = $('<div class="modal fade">');

            $.ajax({
                dataType: "html",
                url: url,
                type: 'get',
                success: function (content) {
                    if (typeof(options.beforeShow) !== 'undefined') {
                        options.beforeShow(content);
                    }
                    container.html(content);
                    container.modal({show: true});

                    if (typeof(options.onShow) !== 'undefined') {
                        options.onShow(container);
                    }

                    container.on('hidden.bs.modal', function () {
                        if (typeof(options.onClose) !== 'undefined') {
                            options.onClose(container);
                        }

                        var form = container.find('form');

                        if (form.length !== 0) {
                            var fv = form.data('formValidation');
                            if (fv) {
                                fv.destroy();
                            }
                        }

                        setTimeout(function () {
                            container.remove();
                            container = null;
                        }, 300);
                    });

                    var form = container.find('form');

                    if (form.length === 0) {
                        return;
                    }

                    container.on('shown.bs.modal', function () {
                        form.formValidation({verbose: false}).on('success.form.fv', function (e) {
                            // Prevent form submission
                            e.preventDefault();
                            var $form = $(e.target),
                                fv = $form.data('formValidation');

                            $.ajax({
                                dataType: "json",
                                url: url,
                                type: 'post',
                                data: $form.serialize(),
                                success: function (response) {
                                    if (typeof(options.onFormSendSuccess) !== 'undefined') {
                                        options.onFormSendSuccess(response, container);
                                    } else {
                                        $form.html(response.message);
                                    }
                                },
                                error: function (xhr) {
                                    if (typeof(options.onFormSendError) !== 'undefined') {
                                        options.onFormSendError(xhr, container);
                                    } else {
                                        if (xhr.status === 422) {
                                            var messages = eval("(" + xhr.responseText + ")");
                                            var errors = $("<ul style='padding: 0; list-style-type: none;'/>");
                                            for (var field in messages) {
                                                errors.append('<li>' + messages[field] + '</li>');
                                            }
                                            var ph = container.find('.errors-placeholder');
                                            if (ph.length > 0) {
                                                ph.html('').append(errors).removeClass('hidden');
                                            }
                                            if (fv.getSubmitButton()) {
                                                fv.disableSubmitButtons(false);
                                            }
                                        }
                                    }
                                }
                            });
                        });
                    });
                }
            });
        }
    };

    return {
        init: function () {
            $(document).on('click', '[data-action=load-modal]', function (e) {
                e.preventDefault();
                _internals.showModal(this, {});
            });
        },
        showModal: function (target, options) {
            _internals.showModal($(target), options);
        }
    }
});